<template>
  <div class="browse-group" v-if="groups.length > 0">
		<div class="browse-group__tab-menu">
			<menu>
				<li v-for="(group,g) in groups" :key="`grp_button_${g}`"
				aria-role="button"
				@click="active_group_index = g"
				:class="[{'active':active_group_index == g}]"
				>{{ group.name }}</li>
			</menu>
		</div>
		<div class="browse-group__tab-group">
			<div class="browse-group__tab-item" v-for="(item,i) in active_group.items" :key="`item_${active_group_index}_${i}`">
				<a :href="`/category/${item.slug}`">
					<div class="upper" :data-theme="item.color">
						<div class="upper__icon"><esc-icon :name="item.icon"></esc-icon></div>
					</div>
					<div class="lower">
						<h4>{{ item.name }}</h4>
						<span>View</span>
					</div>
				</a>
			</div>
		</div>
  </div>
</template>

<script>
	import EscIcon from '@/main/components/icons/EscIcon';

	export default {
		props: {
			payload: {
				type: String
			}
		},
		components: {
      EscIcon
    },
		data() {
			return {
				groups: false,
				active_group_index: 0
			}
		},

    created() {
			this.groups = JSON.parse(this.payload);
			console.log("Groups",this.groups);
		},

		methods: {

		},

    computed: {
			active_group() {
				return this.groups[this.active_group_index];
			}
    }
	}
</script>
